import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoggerService } from 'src/shared/logger/logger.service';
import { enteredDataObj } from './model/EnteredDataObj';
import * as XLSX from 'xlsx';

@Component({
  selector: 'search-dialog',
  templateUrl: './dialog.report-generator.component.html',
  styleUrls: ['./dialog.report-generator.component.css']
})
export class DialogReportGeneratorComponent implements OnInit {
  title = 'VMS-Systems';
  fileName = `VMS Extracted Report${new Date().toISOString()}.csv`;

  constructor(
    public dialogRef: MatDialogRef<DialogReportGeneratorComponent>,
    private loggerService: LoggerService,
    @Inject(MAT_DIALOG_DATA) public data: { stringArr: string[], unitsArr: enteredDataObj[] }) {

  }

  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.dialogRef.close();
  }

  exportExcel(): void {
    /* pass here the table id */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, this.fileName);

  }

}
